import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { buttonStyle } from "./colors";
import pfp from "./icons/pfp.png";

function EditProfile() {
  const navigate = useNavigate();

  return (
    <NavBarLayout
      title="Edit Profile"
      onBackButtonClicked={() => navigate(-1)}
      active={3}
    >
      <div className="EditProfile-container">
        <div className="EditProfile-profile">
          <img
            style={{
              borderRadius: "50%",
              width: 110,
              height: 110,
              background: "black",
            }}
            src={pfp}
            alt=""
          />
          <div className="EditProfile-userDetails">
            <span className="EditProfile-sectionText">Username</span>
            <span className="EditProfile-responseText">hana.dao</span> <br />
            <span>
              <span className="EditProfile-sectionText">Email </span>
              (visible only to you)
            </span>
            <span className="EditProfile-responseText">hana.dao@gmail.com</span>
          </div>
        </div>
        <div className="EditProfile-userPreferences">
          <div className="EditProfile-userPreferencesSection">
            <span>
              <span className="EditProfile-sectionText">Location </span>
              (visible only to you)
            </span>
            <span className="EditProfile-selected">Palo Alto</span>
          </div>
          <div className="EditProfile-userPreferencesSection">
            <span>
              <span className="EditProfile-sectionText">
                Occupation (select){" "}
              </span>
              (visible only to you)
            </span>
            <div className="EditProfile-options">
              <span className="EditProfile-selected">Student</span>
              <span className="EditProfile-notSelected">Teacher</span>
              <span className="EditProfile-notSelected">Software Engineer</span>
            </div>
          </div>
          <div className="EditProfile-userPreferencesSection">
            <span>
              <span className="EditProfile-sectionText">
                Your style (select){" "}
              </span>
              (visible to everyone)
            </span>
            <div className="EditProfile-options">
              <span className="EditProfile-selected">Cute</span>
              <span className="EditProfile-selected">Grungy</span>
              <span className="EditProfile-notSelected">Sporty</span>
              <span className="EditProfile-notSelected">Casual</span>
            </div>
          </div>
          <div className="EditProfile-userPreferencesSection"></div>
        </div>
      </div>
      <Button
        onClick={() => {
          navigate(-1); // change
        }}
        sx={{
          fontSize: 16,
          paddingX: 0,
          margin: "1rem",
          bottom: "10px",
          position: "absolute",
          width: "40%",
          transform: "translate(60%, 0)",
          ...buttonStyle,
        }}
        variant="contained"
      >
        Confirm
      </Button>
    </NavBarLayout>
  );
}

export default EditProfile;
